export const successConstants = {
    subHeading: `# Success!`,
    successText: `#### Thank you, your card has successfully been **activated** and the funds will be available for use by 12pm the following business day.`,
}